import styled from "styled-components"
import * as PropTypes from "prop-types"
import Icon from "components/icons/icon"
import SideArrow from "components/icons/sideArrow"
import Link from "components/Link"

const Button = styled.a`
  display: block;
  width: fit-content;
  height: 24px;
  margin: 0 auto;
  color: white;
  box-shadow: ${({ shadow }) => (shadow ? " 0 2px 14px 0 rgba(195, 205, 224, 0.8)" : "none")};

  &:hover {
    color: ${({ theme }) => theme.colors.silver};
    box-shadow: none;
  }
`

const StyledIcon = styled(Icon)`
  margin-bottom: -4px;
  margin-left: 10px;
`

function ArrowButton({ children, page, ...rest }) {
  return (
    <Link page={page}>
      <Button {...rest}>
        {children}
        <StyledIcon Icon={SideArrow} color="deepPink" />
      </Button>
    </Link>
  )
}

ArrowButton.propTypes = {
  children: PropTypes.node.isRequired,
  page: PropTypes.string.isRequired
}

export default ArrowButton
